import { useCallback } from 'react';
import { useTrackingContext } from '@zapier/toolbox-tracking';

import { GoogleSSOButton } from '../global/GoogleSSOButton';
import { FacebookSSOButton } from '../global/FacebookSSOButton';
import { MicrosoftSSOButton } from '../global/MicrosoftSSOButton';
import { QueryParams, SignupType } from '../../types';
import { ContinueWithSSOButton } from './ContinueWithSSOButton';
import { css } from '@emotion/react';

type Props = {
  next?: string | undefined;
  selectedApis?: string | string[];
  shouldShowFacebookSSO: boolean;
  shouldShowGoogleSSO: boolean;
  shouldShowMicrosoftSSO: boolean;
  shouldShowSAMLSSO: boolean;
  queryParams: QueryParams; // Needed to retain queryParams on the login with identity provider page.
};

const styles = {
  root: css({
    display: 'grid',
    gap: '20px',
  }),
};

export function SocialItems({
  next,
  selectedApis = [],
  shouldShowFacebookSSO,
  shouldShowGoogleSSO,
  shouldShowMicrosoftSSO,
  shouldShowSAMLSSO,
  queryParams,
}: Props) {
  const { trackSignupConversion, trackSignupIntent } = useTrackingContext();

  const onTrackSignupConversion = useCallback(
    async (type: SignupType, userId: string) => {
      return trackSignupConversion(type as any, {
        selectedApis,
        userId,
      });
    },
    [selectedApis, trackSignupConversion]
  );

  const onTrackSignupIntent = useCallback(
    async (type: SignupType) => {
      return trackSignupIntent(type as any, {
        selectedApis,
      });
    },
    [selectedApis, trackSignupIntent]
  );

  return (
    <div css={styles.root}>
      {shouldShowGoogleSSO && <GoogleSSOButton next={next} />}
      {shouldShowFacebookSSO && (
        <FacebookSSOButton
          next={next}
          onTrackSignupConversion={onTrackSignupConversion}
          onTrackSignupIntent={onTrackSignupIntent}
        />
      )}
      {shouldShowMicrosoftSSO && (
        <MicrosoftSSOButton
          next={next}
          onTrackSignupConversion={onTrackSignupConversion}
          onTrackSignupIntent={onTrackSignupIntent}
        />
      )}
      {shouldShowSAMLSSO && <ContinueWithSSOButton queryParams={queryParams} />}
    </div>
  );
}
